import Responsive from './Responsive';
import bowser from 'bowser'
import swiper from 'swiper'

module.exports = function() {
	const $set_height_target = $('.mv .swiper-slide,.mv .slide_wrapper');
	$set_height_target.height($(window).height());
	$(window).on('resize',function(){
		$set_height_target.height($(window).height());
	});

	const wrapper = $('.mv .slide_wrapper');
	const target = '#js-slide-mv';
	let slide_obj = undefined;
	let slide_num = $(target).find('li').length;

	let options = {
		speed:2000,
		autoplay: 2000,
		loop:true,
		effect: 'fade',
		fade: {
		  crossFade: true
		}
	};

	$(window).on('load',function(){
	  new Swiper(target,options);
	});

	if($('body').hasClass('home')){
		const fnav = $('.fixed_header');
		$(window).on('load scroll',function(){
			if($(this).scrollTop() > 200){
				$(fnav).addClass('active');
				$('.btn_sp_navi,.btn_lang_navi').addClass('with_fixed_header');
			}else{
				$(fnav).removeClass('active');
				$('.btn_sp_navi,.btn_lang_navi').removeClass('with_fixed_header');
			}
		});
	}

	// //枚数や画面サイズによって処理を変更したりとか
	// $(window).on('load resize',function(){
	// 	if(typeof slide_obj != 'undefined'){
	// 		slide_obj.destroy( true, true );
	// 		slide_obj = undefined;
	// 	}
	// 	slide__home_wrapper.removeClass('no_slide');

	// 	if(r.state()()){
	// 		slide_obj = new Swiper (target,options);
	// 	}else{
	// 		if(slides > 4){
	// 			slide_obj = new Swiper (target,options);
	// 		}else if($(this).width() < 1281 && slides > 3){
	// 			slide_obj = new Swiper (target,options);
	// 		}else{
	// 			wrapper.addClass('no_slide');
	// 		}
	// 	}
	// });
}



// WEBPACK FOOTER //
// ./dev/js/scripts/mv.js